(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ls-booking"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ls-booking')) {
  customElements.define('ls-booking', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.trigger = this.querySelector('[data-open]');
      this.widget = this.querySelector('[data-widget]');
      this.status = this.querySelector('[role="status"]');
      if (!this.dialog || this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.trigger.addEventListener('click', () => this.openBooking(), options);
      this.dialog.addEventListener('close', () => this.unlockPage(), options);
      // Only dismiss when both the press and release occurred on the backdrop.
      this.dialog.addEventListener('pointerdown', event => {
        this.backdropPress = event.target === this.dialog;
      }, options);
      this.dialog.addEventListener('click', event => {
        if (event.target === this.dialog && this.backdropPress) this.dialog.close();
        this.backdropPress = false;
      }, options);
    }
    openBooking() {
      if (typeof this.dialog.showModal !== 'function') {
        window.location.assign(this.dataset.bookingUrl);
        return;
      }
      if (this.dialog.open) return;
      // Keep only one LS booking modal active, including in the theme editor.
      document.querySelectorAll('ls-booking dialog[open]').forEach(dialog => {
        dialog.close();
        dialog.closest('ls-booking')?.unlockPage();
      });
      this.dialog.showModal();
      if (!this.locked) {
        this.scrollY = window.scrollY;
        this.bodyStyle = ['position', 'top', 'left', 'right', 'width'].map(name => [name, document.body.style.getPropertyValue(name), document.body.style.getPropertyPriority(name)]);
        document.body.style.position = 'fixed';
        document.body.style.top = `-${this.scrollY}px`;
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.style.width = '100%';
        this.locked = true;
      }
      if (!this.mounted) this.mountCalendar();
    }
    unlockPage() {
      if (!this.locked) return;
      this.bodyStyle.forEach(([name, value, priority]) => {
        if (value) document.body.style.setProperty(name, value, priority);
        else document.body.style.removeProperty(name);
      });
      window.scrollTo({ top: this.scrollY, behavior: 'instant' });
      this.locked = false;
    }
    mountCalendar() {
      this.mounted = true;
      const markFrame = () => {
        const frame = this.widget.querySelector('iframe');
        if (!frame) return;
        frame.title = 'LA STORY appointment booking';
        frame.addEventListener('load', () => {
          this.status.hidden = true;
          clearTimeout(this.loadingTimer);
        }, { once: true, signal: this.controller.signal });
        this.observer.disconnect();
      };
      this.observer = new MutationObserver(markFrame);
      this.observer.observe(this.widget, { childList: true, subtree: true });
      this.loadingTimer = setTimeout(() => {
        if (!this.status.hidden) this.status.textContent = 'Taking longer than expected? Use the link below to book in a new tab.';
      }, 20000);
      window.Koalendar = window.Koalendar || function () {
        (window.Koalendar.props = window.Koalendar.props || []).push(arguments);
      };
      window.Koalendar('init');
      window.Koalendar('inline', { url: this.dataset.bookingUrl, selector: '#' + CSS.escape(this.widget.id) });
      const source = 'https://koalendar.com/assets/widget.js';
      if (!Array.from(document.scripts).some(script => script.src === source)) {
        const script = document.createElement('script');
        script.src = source;
        script.async = true;
        script.addEventListener('error', () => {
          if (this.isConnected) this.status.textContent = 'The calendar could not load. Please use the booking link below.';
        }, { once: true });
        document.head.appendChild(script);
      }
      markFrame();
    }
    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      this.unlockPage();
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      clearTimeout(this.loadingTimer);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
